import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChipDirective } from './chip.directive';
import { ChipComponent } from './chip.component';

@NgModule({
  declarations: [ChipDirective, ChipComponent],
  imports: [CommonModule],
  exports: [ChipDirective, ChipComponent],
})
export class ChipModule {}
